import { DCBaseMouseEvent } from "./DCBaseMouseEvent.js";
export class DCMouseUpEvent extends DCBaseMouseEvent {
    eventType = "mouse-up";
    inputType = "mouse";
    constructor() {
        super();
    }
}
